import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { DropdownProps } from './Dropdown';

interface Props {
  children: React.ReactNode;
  className: string;
  dataQa: string;
  forcePositionY?: DropdownProps['forcePositionY'];
  positionX?: DropdownProps['positionX'];
  positionY?: DropdownProps['positionY'];
  /** Toggle to hide the label for all but screen readers */
  screenReaderLabel?: DropdownProps['screenReaderLabel'];
  /** indicates whether you can scroll the position wrapper */
  scroll?: DropdownProps['scroll'];
}

const Position = (props: Props) => {
  const {
    children,
    className,
    dataQa,
    forcePositionY = false,
    positionX = 'down',
    positionY = 'right',
    screenReaderLabel = false,
    scroll = false,
  } = props;

  const element = useRef(null);
  const [horizontalDirection, setHorizontalDirection] = useState(positionX);
  const [verticalDirection, setVerticalDirection] = useState(positionY);

  useEffect(() => {
    const { height, left, top } = element.current.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    const leftEdgePassesWindow = left < 0;
    const bottomEdgePassesWindow = top + height > innerHeight;
    const spaceRightIsGreater = innerWidth - left > left;
    let elementHeight = 'auto';
    let vDirection = positionY;
    let hDirection = positionX;

    if (leftEdgePassesWindow && spaceRightIsGreater) {
      hDirection = 'left';
    }

    if (bottomEdgePassesWindow && !forcePositionY) {
      elementHeight = top;
      vDirection = 'up';
    }

    if (scroll) {
      element.current.style.height = `${elementHeight}px`;
    }

    setVerticalDirection(vDirection);
    setHorizontalDirection(hDirection);
  }, [forcePositionY, positionY, positionX, scroll]);

  return (
    <div
      ref={element}
      className={classNames({
        [className]: true,
        'direction-left': horizontalDirection === 'left',
        'direction-center': horizontalDirection === 'center',
        'direction-up': verticalDirection === 'up',
        'screen-reader-label': screenReaderLabel,
      })}
      data-qa={dataQa}
    >
      {children}
    </div>
  );
};

export default Position;
